import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'tab',
  })
  let previousMonth = useDataValue({
    context: 'resources',
    path: 'open_office_dates.previous_month',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'setDate',
      date: previousMonth,
    })
  }
}
